module.exports = __webpack_public_path__ + "static/media/vacuderma-1.9ffec66b.jpg";